import { getEntity } from '../../../api/accounting';
import { useChatStore } from '../../../stores/chatStore';

export async function loadEntityDetail(entityId: string) {
  try {
    const entity = await getEntity(entityId);
    const store = useChatStore.getState();
    store.addArtifact({
      messageIndex: -1,
      type: `entity-detail:${entity.entityType}`,
      data: {
        entityType: entity.entityType,
        provider: entity.provider,
        externalId: entity.externalId,
        ...entity.data,
      },
    });
  } catch {
    // Silently fail
  }
}
